export interface Article {
  id: string
  title: string
  excerpt: string
  category: string
  url: string
  date: string
}

export const articles: Article[] = [
  {
    id: '1',
    title: 'One Question to Help You Get More Done',
    excerpt:
      'Sometimes the simplest reframe unlocks the biggest shift. Discover the one question that cuts through overwhelm and gets you moving.',
    category: 'Mindset',
    url: 'https://theproductivityblueprint.beehiiv.com/p/one-question-to-help-you-get-more-done-d0ae',
    date: 'Dec 14, 2025',
  },
  {
    id: '2',
    title: 'How to Focus for 12 Hours (Without Burning Out)',
    excerpt:
      "Sustained focus isn't about willpower. Learn the science-backed rhythm of work and rest that lets you go deep without the crash.",
    category: 'Deep Focus',
    url: 'https://theproductivityblueprint.beehiiv.com/p/how-to-focus-for-12-hours-without-burning-out',
    date: 'Nov 06, 2025',
  },
  {
    id: '3',
    title: 'Self Alignment: How to Know What To Do',
    excerpt:
      'When everything feels urgent, nothing gets done. A framework for aligning your daily actions with what actually matters.',
    category: 'Strategy',
    url: 'https://theproductivityblueprint.beehiiv.com/p/self-alignment-how-to-know-what-to-do',
    date: 'Nov 23, 2025',
  },
  {
    id: '4',
    title: 'How to Refocus a Wandering Mind (15 Practical Solutions)',
    excerpt:
      "Your mind will wander. That's not the problem. The problem is not having a system to bring it back. Here are 15 that work.",
    category: 'Attention',
    url: 'https://theproductivityblueprint.beehiiv.com/p/how-to-refocus-a-wandering-mind-15-practical-solutions',
    date: 'Nov 02, 2025',
  },
  {
    id: '5',
    title:
      'To Hammer A Screw: How Having the Right Tools Can Transform Your Outcomes',
    excerpt:
      'Using the wrong tool for the job creates unnecessary friction. Learn how to match your tools to your actual problems.',
    category: 'Systems',
    url: 'https://theproductivityblueprint.beehiiv.com/p/to-hammer-a-screw-how-having-the-right-tools-can-transform-your-outcomes',
    date: 'Dec 07, 2025',
  },
  {
    id: '6',
    title:
      "I Started Taking a Walk Every Morning. Here's What Happened to My Health",
    excerpt:
      'A simple daily walk transformed more than just fitness. The ripple effects on focus, mood, and productivity were unexpected.',
    category: 'Habits',
    url: 'https://theproductivityblueprint.beehiiv.com/p/i-started-taking-a-walk-every-morning-here-s-what-happened-to-my-health',
    date: 'Nov 16, 2025',
  },
]
